var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.5 0C10.0899 0 13 2.91005 13 6.5C13 10.0899 10.0899 13 6.5 13C2.91005 13 0 10.0899 0 6.5C0 2.91005 2.91005 0 6.5 0ZM6.5 1.3C3.6283 1.3 1.3 3.6283 1.3 6.5C1.3 9.3717 3.6283 11.7 6.5 11.7C9.3717 11.7 11.7 9.3717 11.7 6.5C11.7 3.6283 9.3717 1.3 6.5 1.3ZM6.5 1.95C7.1617 1.95 7.79025 2.09105 8.3577 2.3452L7.34175 3.3605C7.0733 3.289 6.7912 3.25 6.5 3.25C4.70535 3.25 3.25 4.70535 3.25 6.5C3.25 7.397 3.614 8.2095 4.2016 8.7984L3.2825 9.7175L3.1811 9.61285C2.418 8.79905 1.95 7.7038 1.95 6.5C1.95 3.9871 3.9871 1.95 6.5 1.95ZM10.6548 4.64295C10.9083 5.20975 11.05 5.83895 11.05 6.5C11.05 7.75645 10.5404 8.89395 9.7175 9.7175L8.7984 8.7984C9.386 8.2095 9.75 7.397 9.75 6.5C9.75 6.2088 9.71165 5.9267 9.6395 5.65825L10.6548 4.64295ZM9.2573 2.82295L10.177 3.74205L7.75645 6.16395C7.78505 6.2712 7.8 6.38365 7.8 6.5C7.8 7.21825 7.21825 7.8 6.5 7.8C5.78175 7.8 5.2 7.21825 5.2 6.5C5.2 5.78175 5.78175 5.2 6.5 5.2C6.61635 5.2 6.7288 5.21495 6.83605 5.24355L9.25795 2.82295H9.2573Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.6012f9400be97e0c1d6c22ee23cddeca.svg";
export { ForwardRef as ReactComponent };